import { useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import classnames from "classnames"
import Logo from "components/logo"
import ContextualMenu from "components/contextual-menu"
import ResourceName from "components/resource-name"
import { useSaveContextPreferences } from "hooks/preferences"
import { LINK } from "../../shapes"
import MobileNavLinkGroup from "./mobile-nav-link-group"
import "./style.scss"

function MobileNav({ portfolioName, isLoading, home, links, menuItems }) {
  const [open, setOpen] = useState(false)

  const saveLastLocationPreference = useSaveContextPreferences("navigation.root")

  const toggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  return <div className={classnames("toggle", { open })} onClick={toggle}>
    <i className="fa fa-bars" />
    <div className={classnames("menu", { open })}>
      {/* The resource actions ride with the name here: below lg the selector that carries them
          on desktop is hidden, and this drawer is the only place the name appears. */}
      <div className="portfolio-name group">
        <ResourceName name={portfolioName} isLoading={isLoading} />
        {/* The whole toggle closes the drawer on click, which would swallow the menu button. */}
        <span onClick={(ev) => ev.stopPropagation()}>
          <ContextualMenu id="mobile-nav-resource-menu" items={menuItems} size="small" />
        </span>
      </div>
      <Link to={home} className="mobile-link group">
        <Logo className="icon" />
        <div className="label">Home</div>
      </Link>
      {links.map(link =>
        <MobileNavLinkGroup key={link.id} link={link} onSaveLastLocation={saveLastLocationPreference} />,
      )}
      <div className="footer">
        <Logo className="logo" />
        <div className="brand">Omega Point</div>
        <div className="product">Portfolio Intelligence</div>
      </div>
    </div>
  </div>
}

MobileNav.propTypes = {
  links: PropTypes.arrayOf(LINK).isRequired,
  portfolioName: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  home: PropTypes.string.isRequired,
  menuItems: PropTypes.array,
}

export default MobileNav
